module.exports = __webpack_public_path__ + "img/bg.5f0c0f12.jpg";